// get from typechain/factories/PhenomCampaign__factory.ts
export const PhenomCampaignABI = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "address",
                name: "_busdAddress",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_seedRoundVestingController",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_privateRoundVestingController",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_communitySaleVestingController",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_fundingTeamVestingController",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_advisorsVestingController",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_marketingVestingController",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "_developmentVestingController",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "enum PhenomCampaign.Phase",
                name: "phase",
                type: "uint8",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "oldPrice",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "uint256",
                name: "newPrive",
                type: "uint256",
            },
        ],
        name: "PriceUpdated",
        type: "event",
    },
    {
        inputs: [],
        name: "CAMPAIGN_DURATION",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "advisorsVestingController",
        outputs: [
            {
                internalType: "contract TokenVesting",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "amountPhetaSoldInPublicRound",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "amountUsdSoldInPublicRound",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_token",
                type: "string",
            },
        ],
        name: "approveExternalBalance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "busd",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_busdAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_maxPrice",
                type: "uint256",
            },
        ],
        name: "buy",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "communitySaleVestingController",
        outputs: [
            {
                internalType: "contract TokenVesting",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "developmentVestingController",
        outputs: [
            {
                internalType: "contract TokenVesting",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fundingTeamVestingController",
        outputs: [
            {
                internalType: "contract TokenVesting",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getAvailableAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_investor",
                type: "address",
            },
        ],
        name: "getAvailableAmountByInvestor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
        ],
        name: "getAvailableAmountByPhase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "_investor",
                type: "address",
            },
        ],
        name: "getAvailableAmountByPhaseAndInvestor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_token",
                type: "string",
            },
        ],
        name: "getExternalBalance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getInvestedAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_investor",
                type: "address",
            },
        ],
        name: "getInvestedAmountByInvestor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
        ],
        name: "getInvestedAmountByPhase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "_investor",
                type: "address",
            },
        ],
        name: "getInvestedAmountByPhaseAndInvestor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getReleasedAmount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_investor",
                type: "address",
            },
        ],
        name: "getReleasedAmountByInvestor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
        ],
        name: "getReleasedAmountByPhase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "_investor",
                type: "address",
            },
        ],
        name: "getReleasedAmountByPhaseAndInvestor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
        ],
        name: "getSupplyByPhase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
        ],
        name: "getWithdrawableAmountByPhase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_token",
                type: "string",
            },
        ],
        name: "hash",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [],
        name: "marketingVestingController",
        outputs: [
            {
                internalType: "contract TokenVesting",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "",
                type: "uint8",
            },
        ],
        name: "preTgePurchaseTotals",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "preTgePurchases",
        outputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "phase",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "buyer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "phetaAmount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "preTgePurchasesCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "",
                type: "uint8",
            },
        ],
        name: "priceByPhase",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "privateRoundVestingController",
        outputs: [
            {
                internalType: "contract TokenVesting",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "publicRoundActive",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "publicSaleRegistry",
        outputs: [
            {
                internalType: "address",
                name: "buyer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "busdAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "phetaAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "date",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "publicSaleRegistryCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
            {
                internalType: "address[]",
                name: "_investors",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "_amounts",
                type: "uint256[]",
            },
        ],
        name: "registerMultiplyPurchases",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
            {
                internalType: "address[]",
                name: "_investors",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "_usdAmounts",
                type: "uint256[]",
            },
        ],
        name: "registerMultiplyUsdPurchases",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "_investor",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "registerPurchase",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "_investor",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_usdAmount",
                type: "uint256",
            },
        ],
        name: "registerUsdPurchase",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "releaseAvailable",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_investor",
                type: "address",
            },
        ],
        name: "releaseAvailableByInvestor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "_investor",
                type: "address",
            },
        ],
        name: "releaseAvailableByPhaseAndInvestor",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "_vestingScheduleId",
                type: "bytes32",
            },
        ],
        name: "revoke",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "seedRoundVestingController",
        outputs: [
            {
                internalType: "contract TokenVesting",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "_balances",
                type: "uint256[]",
            },
            {
                internalType: "bytes32[]",
                name: "_hashes",
                type: "bytes32[]",
            },
        ],
        name: "setExternalBalances",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_time",
                type: "uint256",
            },
        ],
        name: "setVestingStartTime",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "startVestingForLast200PreTgePurchases",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "token",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "_price",
                type: "uint256",
            },
        ],
        name: "updatePrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "vestingStartTime",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum PhenomCampaign.Phase",
                name: "_phase",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "withdraw",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
]

